"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSizeWithLimit = void 0;
const calculateSizeWithLimit = ({ size, limit, offset, }) => {
    if (!limit || offset + size < limit) {
        return size;
    }
    return Math.max(0, limit - offset);
};
exports.calculateSizeWithLimit = calculateSizeWithLimit;
//# sourceMappingURL=calculateSizeWithLimit.js.map